export { Divider, DividerVariant, type IDividerProps } from './divider';
